var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-course-tag"},[_c('van-icon',{staticClass:"my-course-tag__icon",attrs:{"name":"checked"}}),_c('span',{staticClass:"my-course-tag__text"},[_vm._v("已兑换")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }